import { createContext } from 'react'
import { HistoryContextProps } from '../HistoryEntry/HistoryContext'
import HistoryEntry from '../HistoryEntry/HistoryEntry'

export type ResultOption = {
  [key: string]: string
  label: string
  value: string
}

export const AddressHistoryContext = createContext<HistoryContextProps<AddressHistoryEntry>>({
  dispatch: () => { }
})

export type DisplayState = 'SEARCH_RESULTS' | 'MANUAL_ENTRY'
export interface AddressDetails {
  flatNumber?: string
  buildingName?: string
  buildingNumber?: string
  street?: string
  town?: string
  county?: string
  postcode?: string
  id?: string
}

export interface AddressHistoryEntry extends HistoryEntry {
  addressSituation?: string
  addressDetails?: AddressDetails
  displayState?: DisplayState
  loqateResults?: ResultOption[]
  addressLabel?: string | null
  postcodeSearchAttempted?: boolean
  question?: number
}
export interface AddressEntryErrors {
  flatNumber?: string
  buildingName?: string
  buildingNumber?: string
  street?: string
  town?: string
  county?: string
  postcode?: string
  years?: string,
  months?: string,
  duration?: string,
  addressSituation?: string,
}

export interface AddressHistoryState {
  entries: Record<string, AddressHistoryEntry>
  questionToEdit?: string
  questionChangeAction?: 'next' | 'prev'
  question?: number,
  backToAddressList?: boolean
}
